<template>
    <div>
        <main class="app-content">
          <div class="app-title">
            <div>
              <h1><v-icon color="black">mdi-layers-triple</v-icon>Facturas Electronicas COMPRAS</h1>
              <p>Carga masiva de archivos xml fel COMPRAS</p>
            </div>
            <ul class="app-breadcrumb breadcrumb">
              <v-btn class="white--text" color="red" @click="$router.go(-1),limpiar">
                  <v-icon left>mdi-close-circle-outline</v-icon>
                  Cerrar
              </v-btn>
            </ul>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="tile">              
                    <v-row>
                        <v-col>
                            
                            <v-file-input
                                v-model="files"
                                color="blue"
                                counter
                                label="Seleccione los archivos XML"
                                multiple
                                accept="text/xml"
                                placeholder="Select sus archivos XML"
                                prepend-icon="mdi-paperclip"
                                @change="loadfiles"
                                outlined
                                >
                                <template v-slot:selection="{ index, text }">
                                <v-chip v-if="index < 3" color="blue" dark label small>
                                    {{ text }}
                                </v-chip>

                                <span
                                    v-else-if="index === 3"
                                    class="overline grey--text text--darken-3 mx-2"
                                >
                                    +{{ files.length - 3 }} Archivo(s)
                                </span>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="4">
                            <v-select v-model="estadoseleccionado" :items="estado" hide-selected label="Estado Facturas" color="blue" outlined></v-select>
                        </v-col>
                    </v-row>
                   <v-divider></v-divider>
                   <v-row >
                       <v-col cols="8">
                           <h5>{{this.$store.getters.getCompra.Nit+' - '+this.$store.getters.getCompra.Establecimiento}}</h5>
                       </v-col>
                       <v-col cols="4" v-show="DTE.length>0">
                            <v-btn @click="procesarFel" color="green" class="text-white"> <v-icon color="white">mdi-layers-triple</v-icon>Procesar Facturas</v-btn> | 
                            <v-btn @click="limpiar()" color="blue" class="text-white"> <v-icon color="white">mdi-table-off</v-icon> Vaciar Tabla</v-btn>
                       </v-col>
                   </v-row>
                    <v-row>
                        <v-col>
                        <v-data-table
                        :headers="headers"
                        :items="DTE"
                        :items-per-page="10"
                        calculate-widths
                        class="elevation-1"
                        ></v-data-table>
                        </v-col>
                    </v-row>
                
              </div>
            </div>
          </div>
  <!-- DIALOG CARGANDO -->        
  <div class="text-center">
        <v-dialog v-model="dialog" hide-overlay persistent width="300" >
        <v-card color="teal" dark>
            <v-card-text>
            {{cargadotexto}}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
        </v-dialog>
    </div>
        </main>

    </div>
</template>
<script>
import axios from 'axios'
import {ProcesarXML} from '@/libs/dtecompras'
import Swal from 'sweetalert2'
import currency from '@/libs/currency'
export default {
    name:'FelCompras',
    data() {
        return {
            dialog:false,
            cargadotexto:'',
            files: [],
            urlapi:this.$store.getters.getUrlApi,
            estadoseleccionado:'Recibida',
            estado: ['Recibida','Combustible'],
            headers: [
            { text: 'FechaFactura', value: 'FechaFactura'},
            { text: 'Serie', value: 'Serie'},
            { text: 'Numero Factura', value: 'NumeroFactura'},
            { text: 'Nit', value: 'Nit'},
            { text: 'Cliente', value: 'Proveedor'},
            { text: 'Total Factura', value: 'total'},
            { text: 'Total Sin Iva', value: 'TotalSinIVA'},
            { text: 'Iva', value: 'IVA'},
            { text: 'Estado', value: 'Estado'}
            ],
            DTE:[],
            totalcompras:0
        }
    },
    created() {
        this.$store.dispatch("deleteFacturas")
    },
    computed:{
        FacturasFel() {
        return this.$store.getters.getFacturas
        },
    },
    methods: {
        loadfiles(e){
            this.dialog=true;
            this.cargadotexto='Cargando Archivos...'

            e.forEach(element => {
               ProcesarXML(element,this.estadoseleccionado,this.$store.getters.getCompra.IdCompra)
            });

           this.DTE = this.$store.getters.getFacturas
           this.dialog=false;     
          },
          procesarFel(){  
            this.dialog=true;
            this.cargadotexto='Procesando Facturas..'          
            axios.post(`${this.urlapi}/facturascompras/fel`,this.DTE,{headers:{'auth-user':this.$store.getters.getToken}}).then(()=>{
                this.dialog=false;
                this.actualizartotales()
                this.exitoSwal('Facturas Procesadas','')
                this.limpiar()
              }).catch(err=>{console.log(err),this.dialog=false,this.errorSwal('Error al procesar las Facturas','')})
              
          },
          limpiar(){
              this.$store.dispatch("deleteFacturas") 
              this.DTE=[]
              this.files=[]
          },
          actualizartotales(){
              const total_actual= currency(this.$store.getters.getCompra.Total,2).value
              const sumatotal = total_actual + this.DTE.reduce((acumulado,item)=>acumulado+parseFloat(item.total),0)
              this.$store.dispatch("setTotalCompra",sumatotal)
          },
         //Mesajes Sweet Alert
        errorSwal(titulo,texto){
            Swal.fire({
                title:titulo+' 😦',
                text:texto,
                icon:'error'
            })
        },
        exitoSwal(titulo,texto){
            Swal.fire({
                icon: 'success',
                title: titulo+' 😦',
                text:texto,
                showConfirmButton: false,
                timer: 1500
            })
        }, 
    },
}
</script>